{
	"title": "Cambiar contraseña",
	"labels": {
		"company": "Compañía",
		"password": "Contraseña",
		"confirmPassword": "Confirmar contraseña"
	},
	"fields": {
		"organization": {
			"placeholder": "Ingresa la compañía",
			"required": "La compañía es requerida"
		},
		"password": {
			"placeholder": "Ingresa tu contraseña",
			"required": "La contraseña es requerida",
			"invalid": "Contraseña inválida"
		},
		"confirmPassword": {
			"placeholder": "Confirma tu contraseña",
			"required": "La confirmación de contraseña es requerida",
			"invalid": "La confirmación de contraseña es inválida"
		},
		"errors": {
			"required": "El campo es requerido",
			"passwordMustBeSame": "La contraseña y la confirmación de contraseña no coinciden",
			"tokenRequired": "El token es requerido",
			"organizationRequired": "La organización es requerida"
		}
	},
	"submit": "Guardar nueva contraseña",
	"successModal": {
		"title": "La nueva contraseña ha sido guardada con éxito!",
		"subtitle": "Ahora puedes acceder al Dashboard Zig con tu nueva contraseña.",
		"btnTitle": "Iniciar sesión"
	},
	"passwordRules": {
		"minLength": "Mínimo de 8 caracteres",
		"uppercase": "Al menos 1 letra mayúscula",
		"lowercase": "Al menos 1 letra minúscula",
		"number": "Al menos 1 número",
		"special": "Al menos 1 carácter especial (!@#$...)"
	},
	"passwordRuleState": {
		"passed": "cumplido",
		"failed": "no cumplido"
	},
	"passwordStrength": {
		"weak": "Débil",
		"fair": "Aceptable",
		"strong": "Fuerte",
		"veryStrong": "Muy fuerte",
		"ariaLabel": "Fuerza de la contraseña: {{level}}"
	},
	"passwordMatch": {
		"mismatch": "Las contraseñas no coinciden"
	}
}
